import { render, staticRenderFns } from "./configAlarm.vue?vue&type=template&id=5d06e178&"
import script from "./configAlarm.vue?vue&type=script&lang=js&"
export * from "./configAlarm.vue?vue&type=script&lang=js&"
import style0 from "./configAlarm.vue?vue&type=style&index=0&id=5d06e178&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports